<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({ name: 'RegionalManagerUsersRoutesCreate' }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("newRoute") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
          </template>

          <template v-slot:item.nome="{ item }">
            <a
              class="lime--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  'regionalManager/routes/getRoute'
                )
              "
            >
              <v-icon color="lime" small>mdi-map</v-icon>
              {{ item.nome }}
            </a>
          </template>

          <template v-slot:item.nome_arrecadador="{ item }">
            <a
              class="light-green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_collector,
                  'regionalManager/collectors/getCollector'
                )
              "
            >
              <v-icon color="light-green" small>mdi-account-cash</v-icon>
              {{ item.nome_arrecadador }}
            </a>
          </template>

          <!-- Column Action -->
          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-btn
                small
                :title="$t('profile')"
                @click="
                  $profile.showProfileDrawer(
                    item.id,
                    'regionalManager/routes/getRoute'
                  )
                "
              >
                <v-icon>mdi-map</v-icon>
              </v-btn>
              <v-btn
                small
                :title="$t('edit')"
                @click="
                  [
                    $router.push({
                      name: 'RegionalManagerUsersRoutesEdit',
                      params: { id: item.id },
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon size="24">mdi-pencil</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-manager-users-routes-list",
  components: {
    HeaderPrint,
  },
  data: () => ({
    items: [],
    search: "",
  }),
  async mounted() {
    this.getRoutesList();
  },
  computed: {
    refresh() {
      return this.$store.getters.getRefresh;
    },
    headers() {
      return [
        { text: this.$t("idLabel"), value: "id" },
        { text: this.$t("routeName"), value: "nome" },
        { text: this.$t("collectorLabel"), value: "nome_arrecadador" },
        {
          text: this.$t("actionsLabel"),
          value: "action",
          align: "center d-print-none",
        },
      ];
    },
  },
  watch: {
    refresh(val) {
      val && this.getRoutesList();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    resetPage() {
      this.search = "";
    },

    async getRoutesList() {
      this.resetPage();
      const request = await this.$request.get("/regionalManager/routes/list");
      this.items = request.length == 0 ? [] : request.dados;
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
  },
};
</script>
